import React, { useState } from 'react'
import { Table, Tag, Space,Image } from 'antd';
import styled from 'styled-components'
import { FaRegTrashAlt, FaRegEdit } from 'react-icons/fa';
import DeleteConfirm from '../../shared/deleteConfirm'
import {MdDelete} from 'react-icons/md'
import Loader from '../../shared/loaderImg';





export default function PartTable({data,deleteEvent}) {

    

    const [image,setImgurl] = useState(data)

    const confirm = (e, id) => {
      console.log({id})
      deleteEvent(id)
      }
      
      const cancel = (e) =>{
        return null
      }

    const remove = (e, url) =>{
    
        console.log({url})
        setImgurl(prev => prev.filter(item => item !== url))
        
        }

console.log({data})
      
      const columns = [

        {
          title: 'Image',
          key: "image",
           
          render: (t, k, i) => <div>
                   
          <Image    
           preview={false}               
           key={i}
           style={{height:"50px", width:"50px", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
           src={t.image}
           placeholder={<Loader/> }              
         />   

          {/* <h2 onClick={(e)=>removeeventImage(e,img?.image,eId)} className=" text-black  "> <MdDelete/></h2>  */}

            </div>
        },
        {
          title:"Caption",
          key : "caption",
          render:(t,i,k)=><p>{t.caption}</p>
        },
    
    
       
        {
          title: 'Action',
          key: 'action',
          render: (id, k, i) => (
            <Space size="middle">      
                   {/* <h5  onClick={(e)=>console.log(e)}  style={{cursor:"pointer", color: 'var(--brandColor' }} className="text-secondary  m-0 ">
                    <FaRegEdit />   
                    </h5>  */}
    
                    <h5 className="text-danger"  >                         
                      <DeleteConfirm  confirm={(e)=>confirm(e, id)} cancel={cancel} title="college"  >
                      <FaRegTrashAlt style={{cursor:"pointer", color:"#e43d3d"}} />
                      </DeleteConfirm>                    
                  </h5>
            </Space>
        ),
      },
    ];


      
      return (
        // <div>
        //     {
        //             data.map((item,i)=>{
        //                 return <div className='imglist' style={{width:'300px',display:'flex',flexDirection:'column'}}>
        //                     <div>
        //                      <Image    
        //            preview={false}               
        //            key={i}
        //            style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover',marginLeft:'12px'}}
        //            src={item.image}
        //            placeholder={<Loader/> }              
        //          /></div>   

        //           <h2  onClick={(e)=>remove(e, item.image)} className=" text-white  "> <MdDelete/></h2> 
        //           <div>
        //             <p style={{marginLeft:'12px'}}>{item.caption}</p>
        //             </div>
        //                     </div>

        //             })
        //     }
          
        // </div>
        <DataTableWrap>
        <div className=" rounded-md" style={{backgroundColor:'#ffffff', border:'0px solid #dadada'}}> 
 { 
   <Table 
 pagination={false}
//  loading={isLoading}
 columns={columns} 
//  rowKey={(record)=>record._id}
 dataSource={data} 
 />
 }            
</div>
   </DataTableWrap> 
          
        )
    }
      
    
    const DataTableWrap = styled.div`

    position : relative;
    margin-bottom: 30px;

    thead[class*="ant-table-thead"] th {
        background-color: #f0f0f0 !important;
      }

      .ant-table-tbody > tr > td {  
        background-color: #FAFAFA !important;
      }
`